import React, { useEffect, useState } from 'react';
import { SubmitContainer } from './Profile.style';
import { BrandIconSpinner, Button, Input } from 'components';
import { t } from 'i18next';
import {
  getProfileByuserName,
  updateProfileFun,
  updateProfileList,
} from 'redux/features/ProfileSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Notification } from 'components/CustomNotification';

export default function Summary({ onClose, profileData }) {
  const dispatch = useDispatch();
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [summary, setsummary] = useState('');
  const [loading, setloading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setsummary(profileData?.personal?.summary);
  }, [profileData]);

  const Submit = () => {
    if (!summary?.trim()) {
      setError('Field Required');
    } else {
      setloading(true);
      const formData = new FormData();
      formData.set('summary', summary);
      dispatch(updateProfileList(formData, getProfile?.userId, 'createProfile'))
        .then(() => {
          dispatch(getProfileByuserName());
          dispatch(updateProfileFun(''));
          Notification('success', 'Summary updated successfully');
          onClose(false, 'summary');
          setloading(false);
        })
        .catch((err) => {
          Notification('warning', err.response?.data?.message);
          setloading(false);
        });
    }
  };

  return (
    <>
      <BrandIconSpinner loading={loading} />
      <Input
        label={t('profile.Summary')}
        value={summary}
        errMsg={error}
        minRows={5}
        multiline
        maxLimit={400}
        onChange={(data) => setsummary(data)}
      />
      <SubmitContainer className="modal-footer">
        <Button label={t('profile.Submit')} onClick={Submit} type="text" />
        <Button
          label={t('profile.Close')}
          onClick={() => onClose(false, 'summary')}
          type="text"
        />
      </SubmitContainer>
    </>
  );
}
